import * as csobAddons from './csobV1/addons'
import * as generaliAddons from './generaliV1/addons'
import * as genertelAddons from './genertelV1/addons'
import * as implementations from './implementations'
import * as komunalnaAddons from './komunalnaV1/addons'
import * as unionV2Addons from './unionV2/addons'
import * as uniqaAddons from './uniqaV1/addons'


export const ADDON_DEFAULT = {
  [implementations.IMPLEMENTATION_CSOB_V1]: {
    [csobAddons.ADDON_GLASS]: csobAddons.GLASS_COVERAGE_DEFAULT,
  },
  [implementations.IMPLEMENTATION_GENERALI_V1]: {
    [generaliAddons.ADDON_GLASS]: generaliAddons.GLASS_COVERAGE_DEFAULT,
  },
  [implementations.IMPLEMENTATION_GENERTEL_V1]: {
    [genertelAddons.ADDON_MINICASCO]: genertelAddons.MINICASCO_COVERAGE_DEFAULT,
    [genertelAddons.ADDON_THEFT]: genertelAddons.THEFT_COVERAGE_DEFAULT,
  },
  [implementations.IMPLEMENTATION_KOMUNALNA_V1]: {
    [komunalnaAddons.ADDON_ANIMAL]: komunalnaAddons.ANIMAL_COVERAGE_DEFAULT,
    [komunalnaAddons.ADDON_ASSISTANCE]: komunalnaAddons.ASSISTANCE_COVERAGE_DEFAULT,
    [komunalnaAddons.ADDON_GLASS]: komunalnaAddons.GLASS_COVERAGE_DEFAULT,
    [komunalnaAddons.ADDON_THEFT]: komunalnaAddons.THEFT_COVERAGE_DEFAULT,
  },
  [implementations.IMPLEMENTATION_UNION_V2]: {
    [unionV2Addons.ADDON_ANIMAL]: unionV2Addons.ANIMAL_COVERAGE_DEFAULT,
    [unionV2Addons.ADDON_ASSISTANCE]: unionV2Addons.ASSISTANCE_COVERAGE_DEFAULT,
    [unionV2Addons.ADDON_GLASS]: unionV2Addons.GLASS_COVERAGE_DEFAULT,
    [unionV2Addons.ADDON_INJURY]: unionV2Addons.INJURY_COVERAGE_DEFAULT,
    [unionV2Addons.ADDON_LUGGAGE]: unionV2Addons.LUGGAGE_COVERAGE_DEFAULT,
  },
  [implementations.IMPLEMENTATION_UNIQA_V1]: {
    [uniqaAddons.ADDON_ANIMAL]: uniqaAddons.ANIMAL_COVERAGE_DEFAULT,
    [uniqaAddons.ADDON_ELEMENT]: uniqaAddons.ELEMENT_COVERAGE_DEFAULT,
    [uniqaAddons.ADDON_GLASS]: uniqaAddons.GLASS_COVERAGE_DEFAULT,
    [uniqaAddons.ADDON_INJURY]: uniqaAddons.INJURY_COVERAGE_DEFAULT,
    [uniqaAddons.ADDON_LUGGAGE]: uniqaAddons.LUGGAGE_COVERAGE_DEFAULT,
    [uniqaAddons.ADDON_THEFT]: uniqaAddons.THEFT_COVERAGE_DEFAULT,
    [uniqaAddons.ADDON_VANDALISM]: uniqaAddons.VANDALISM_COVERAGE_DEFAULT,
  },
}
